import Vue from 'vue';
import Router from 'vue-router';

import { User } from "./logic/User";
import { Notifications } from "./notification"

import Home from '@/views/Home';
import Login from '@/views/Login';
import Dashboard from '@/views/Dashboard';
import ProjectDetail from '@/views/ProjectDetail';
import BucketDetail from '@/views/BucketDetail';

Vue.use(Router);

const router = new Router({
  //mode: "history",
  routes: [
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        requiresAuth: false,
        redirectIfAuth: true
      }
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/project/:id',
      name: 'ProjectDetail',
      component: ProjectDetail,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/project/:project_id/bucket/:id',
      name: 'BucketDetail',
      component: BucketDetail,
      meta: {
        requiresAuth: true
      }
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  const currentUser = await User.isSignedIn();
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const redirectIfAuth = to.matched.some(record => record.meta.redirectIfAuth);

  if (requiresAuth && !currentUser) {
    Notifications.show("You were not signed in.");
    next('/login')
  }
  else if (currentUser && redirectIfAuth) next('/dashboard');
  else next();
});

export default router;
